import { createSvgIcon } from '@ori-ui/mui-bundle/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.351-2.144a.5.5 0 1 0-.702-.712l-4.708 4.65-2.13-1.686a.5.5 0 0 0-.621.784l2.825 2.234z"
}), 'CheckCircleFilled');
//# sourceMappingURL=index.js.map